<template>
    <div class="popup" style="background: #fff">
     <div>
     
      <el-form class="demo-form-inline" label-width="150px">
  
  
        <el-form-item label="学生:">
             <el-input placeholder="搜索学生" clearable v-model="formDate.student"></el-input>
          </el-form-item>
  
        
  
        <el-form-item label="所在地域:">
          <el-select
            placeholder="请选择所在地域"
            v-model="formDate.teacher"
            style="width: 100%"
            clearable
            filterable>
            <el-option v-for="item in teacherArr" :key="item.id" :label="item.dictValue" style="margin-left: 10px"
              :value="item.dictType"></el-option>
          </el-select>
        </el-form-item>
  
  
        <el-form-item label="年级:">
             <el-cascader   placeholder="请选择年级" clearable style="width: 100%;" v-model="formDate.student1" :options="gradeList"  :props="props"></el-cascader>
        </el-form-item>
  
  
        <el-form-item label="学生类型:">
          <el-select
            placeholder="请选择学生类型"
            v-model="formDate.curriculum"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in newClassTypeList"
              :key="item.id"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
  
        <el-form-item label="销售:">
          <el-select
            placeholder="请选择销售"
            v-model="formDate.teachingMethods"
            style="width: 100%"
            clearable
            filterable >
            <el-option
              v-for="item in teachingMethodsArr"
              :key="item.id"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="规划师">
            <el-select v-model="searchSource222" clearable filterable   placeholder="请选择是否结清">
              <el-option v-for="item in sources222" :key="item.teacherId" :label="item.teacherName" :value="item.teacherId"></el-option>
            </el-select>
       </el-form-item>
  
  
        <el-form-item label="跟进助理:">
          <el-select
            placeholder="请选择跟进助理"
            v-model="formDate.deleteMethod"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in teachers1"
              :key="item.id"
              :label="item.realname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="状态:">
          <el-select
            placeholder="请选择状态"
            v-model="formDate.deleteMethod1"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in deleteMethoArr"
              :key="item.value"
              :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学科组:" >
          <el-select v-model="formDate.subjectGroupId" clearable filterable placeholder="请选择学科组"  style="width: 100%;">
            <el-option v-for="item in SubjectGroupList" :key="item.categoryIds" :label="item.teacherName"  :value="item.categoryIds"></el-option>
          </el-select>    
        </el-form-item>
        
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="formDate.deleteTime"
            style="width: 100%"
            clearable
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM">
          </el-date-picker>
        </el-form-item>

        
        <el-form-item label="完成时间">
            <el-date-picker
            style="width: 100%"
            v-model="formDate.dateTime"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-form-item>



  
      </el-form>
  
      <p style="width: 98%; text-align: right">
        <el-button type="primary" @click="getBatchDownload" size="small" class="btns" icon="el-icon-download" >批量下载</el-button>
        <el-button type="primary" @click="searchBtn" size="small" class="btns" icon="el-icon-search" >搜索</el-button>
        <el-button type="primary"  @click="clearBtn" class="btns" size="small" icon="el-icon-close">清空</el-button >
        <el-button type="primary"  @click="downloadBtn" class="btns" size="small" icon="el-icon-download">导出</el-button >
      </p>
  
      <el-table :data="tableData"  height="700" stripe style="width: 99%; margin: 20px auto"  border  :header-cell-style="{ background: '#fafafa','text-align': 'center', }" :cell-style="{ 'text-align': 'center' }"
        loading-text="数据加载中" v-loading="isLoading" >
        <el-table-column prop="realname" label="学生" > </el-table-column>
        <el-table-column prop="sex" label="性别" > 
          <template slot-scope="scope">
            <span v-if="scope.row.sex === 1">男</span>
            <span v-if="scope.row.sex === 2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="regionName" label="所在地域" ></el-table-column>
        <el-table-column prop="grade" label="年级" width="150"></el-table-column>
        <el-table-column prop="assistantName" label="助理" ></el-table-column>
        <el-table-column prop="saleName" label="销售" ></el-table-column>
        <el-table-column prop="projectTeacherName" label="规划师" ></el-table-column>
        <el-table-column prop="classType" label="学生类型"> 
           <template slot-scope="scope">
            <span v-if="scope.row.classType === 1">规划</span>
            <span v-if="scope.row.classType === 2">线下</span>
            <span v-if="scope.row.classType === 3">纯补课</span>
          </template>
        </el-table-column>
        <el-table-column prop="accomplishPercent" label="完成进度"></el-table-column>
        <el-table-column prop="accomplishStatus" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.accomplishStatus === 1">未完成</span>
            <span v-if="scope.row.accomplishStatus === 2">已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="200"></el-table-column>
        <el-table-column prop="accomplishDate" label="完成时间" width="200"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
              <el-button type="text" style="color:#00aaff;" @click="handleClickView('查看', scope.row)">查看</el-button>
              <!-- <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
  
      <el-pagination
        style="margin-bottom: 100px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNo"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next"
        :total="pagination.total">
      </el-pagination>
  
    </div>


    <el-dialog :visible="ComprehensiveFeedbackShow" center title="综合反馈" modal-append-to-body append-to-body :close-on-click-modal="false" :before-close="comprehensiveFeedbackCloseDialog" width="80%" >
      <comprehensiveFeedback  :createDate="createDate"  :studentData="studentData"  v-if="ComprehensiveFeedbackShow"></comprehensiveFeedback>
    </el-dialog>

  
    </div>
</template>
  
  <script>
  import { getTeachers, getStudents,  getSubject, getStudentsType } from "@/api/fiveClassApi"
  import {  getList, ApiExhortNews, ApiStatus, ApigetStudentMsgList, ApigetSubjectMsgList, getListApi } from "@/api/weekendReminder"
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import loadingUtils from "../utils/loading";
  
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import { isReturn } from "../utils/retnue";

  import comprehensiveFeedback from "../manager/components/subassembly/comprehensiveFeedback.vue";

  import JSZip from 'jszip';
  import { saveAs } from 'file-saver';

  export default {
    components:{  comprehensiveFeedback },
    data(){
      return{

        searchSource222:'',
        sources222:[],

        newClassTypeList:[  {id:1,name:'规划'}, {id:2,name:'线下'}, {id:3,name:'纯补课'}, ],
  
        dataTop: {
          xueguanshenhezhong:0,
          teacherOk:0,
          teacherDaiTiJiao:0,
          marketOk:0,
          marketNotOk:0,
        },
  
        formDate: {
            student:"",
            teacher:"",
            student1:[],
            curriculum:"",
            teachingMethods:"",
            deleteMethod:"",
            deleteTime:[],
            dateTime:[],
            deleteMethod1:"",
            subjectGroupId:"",
        },

        SubjectGroupList:[],
  
        ewReminder:{
          teacher:"",
          student:"",
          subject:"",
        },
  
        pagination:{
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },

        gradeList: [],
        props: {
          label: "gradeName",
          children: "children",
          value: "id"
        },
  
        tableData: [],
  
        studentArr:[],
        studentArr1:[],
  
        teacherArr:[],
        subjectArr:[],
        teacherCompletedArr:[{ value: 1, label: "进行中" },{ value: 2, label: "已完成" }],
        salesCompletedArr:[{ value: 2, label: "未完成" },{ value: 1, label: "已完成" }],
        salesReviewArr:[{ value: 3, label: "已审阅" },{ value: 2, label: "未审阅" },{ value: 1, label: "初始待提交" }],
        teachingMethodsArr:[
          { name:"王威", id:'10014' },
          { name:"杨佳琪", id:'10015' },
          { name:"邓乔", id:'17620487163' },
          { name:"陈铮", id:'15210610322' },
          { name:"赵薇", id:'18768101243' },
          { name:"苏芮", id:'15201251274' },
          { name:"夏欢", id:'17501112761' },
          { name:"杨晴媛", id:'15201013088' },
        ],
        classTypeArr:[{ value: 1, label: "规划" },{ value: 2, label: "线下" },{ value: 3, label: "纯补课" }],
        deleteMethoArr:[{ value: 1, label: "未完成" },{ value: 2, label: "已完成" },],

        isNewReminder:false,
        screenshotShow:false,
        screenshot:"",
        fileLists:[],
  
  
        isShowImg:false,
        showImg:"",
  
        isLoading:true,
  
        showMsg:null,
  
  
        studentArr_s:[],
        subjectArr_s:[],
  
        showChatDetailTask:false,
        row:null,



        ComprehensiveFeedbackShow: false,
        ComprehensiveFeedbackType: "",

        studentData: null,

        teachers1: [],

        tableDataImg: [],
  
      }
    },
  
    mounted(){
      this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))
      this.handleInitialization()
      this.handleGETImgList()
      this.getListData()
      this.sources222 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
      // this.handleApiGetMessageState()
    },
  
    methods:{

      handleGETImgList(){
        let data = {
            projectTeacherId: this.searchSource222,
            pageNum: this.pagination.pageNo,
            pageSize: this.pagination.pageSize,
            realname: this.formDate.student,
            regionName: this.formDate.teacher ? this.formDate.teacher : "1,2,3",
            gradeList: this.formDate.student1,
            classType: this.formDate.curriculum,
            saleId: this.formDate.teachingMethods,
            assistantId: this.formDate.deleteMethod,
            accomplishStatus: this.formDate.deleteMethod1,
            createStartDate: this.formDate.deleteTime.length > 1 ? this.formDate.deleteTime[0] : "",
            createEndDate: this.formDate.deleteTime.length > 1 ? this.formDate.deleteTime[1] : "",
            accomplishStartDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[0] : "",
            accomplishEndDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[1] : "",
            subjectGroupId: this.formDate.subjectGroupId,
        }
        axios.post(`${apiBaseUrl}/studentFeedback/findStudentPageData`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }) .then((res)=>{
         if(res.data.code == 200){
            if(res.data.data){
              this.tableDataImg = res.data.data ? res.data.data : []
            }else{
              this.tableDataImg =  []
            }
         }else{
           this.tableDataImg =  []
         }
        }).catch((err)=>{
          this.tableDataImg = []
        })
      },

      // 提取扩展名
      getExtension(url) {
        const match = url.match(/\.([a-zA-Z0-9]+)(\?|#|$)/);
        return match ? '.' + match[1] : '.bin';
      },

      getBatchDownload(){

          
        
          const zip = new JSZip()
          const downloadPromises = []

          const now = new Date();
          const timezoneOffsetMs = now.getTimezoneOffset() * 60 * 1000;
          const fileDate = new Date(now - timezoneOffsetMs); // 转换为“UTC 时间 = 本地时间”



          if (Array.isArray(this.tableDataImg) && this.tableDataImg.length > 0) {
            loadingUtils.startLoading();
            this.tableDataImg.forEach(items => {
              if (items && items !== "[]") {
                try {
                  const fileObjNew = JSON.parse(items)
                  fileObjNew.forEach(fileObj => {
                    const fileName = `${fileObj.name}`
                    let urls = fileObj.url.replace('+', '%2B');
                    const downloadPromise = fetch(urls)
                      .then(response => {
                        if (!response.ok) {
                          throw new Error(`下载失败: ${urls} (状态 ${response.status})`)
                        }
                        return response.blob()
                      })
                      .then(blob => {
                        const fileOptions = {
                             binary: true,
                             compression: "DEFLATE",
                             compressionOptions: { level: 6 },
                             date: fileDate  // ✅ 使用修正后的时间
                         }
                         zip.file(fileName, blob, fileOptions)
                      })
                      .catch(err => {
                        setTimeout(() => {
                          loadingUtils.endLoading();
                        }, 500);
                        console.warn(err.message)
                      })
                    downloadPromises.push(downloadPromise)
                  })
                } catch (error) {
                  setTimeout(() => {
                    loadingUtils.endLoading();
                  }, 500);
                  console.error('JSON解析错误:', error)
                }
              }
            })
          }

          // 等待所有文件下载完成
          Promise.all(downloadPromises)
            .then(() => {
              // 生成ZIP文件
              const zipOptions = {
                  type: "blob",
                  compression: "DEFLATE",
                  compressionOptions: { level: 6 },
              }
               return zip.generateAsync(zipOptions)

            })
            .then(content => {
              // 下载ZIP文件
              saveAs(content, `综合反馈.zip`)
              this.$message.success('文件打包成功')
              setTimeout(() => {
                loadingUtils.endLoading();
              }, 500);
            })
            .catch(error => {
              console.error('打包失败:', error)
              this.$message.error('文件打包失败')
              setTimeout(() => {
                loadingUtils.endLoading();
              }, 500);
            })

      },

      comprehensiveFeedbackCloseDialog(){
        this.ComprehensiveFeedbackShow = false
        this.ComprehensiveFeedbackType = ""
        this.studentData = null
      },

      handleClickView(type, row) {

        if (type === "查看") {
           this.studentData = row
           this.createDate = row.createDate
           this.ComprehensiveFeedbackShow = true
           this.ComprehensiveFeedbackType = '查看'
        }    

        if (type === "编辑") {
           this.studentData = row
           this.createDate = row.createDate
           this.ComprehensiveFeedbackShow = true
           this.ComprehensiveFeedbackType = '编辑'
        }

      },
    
      downloadBtn(){
        loadingUtils.startLoading();
        
        const data = {
            projectTeacherId: this.searchSource222,
            pageNum: this.pagination.pageNo,
            pageSize: this.pagination.pageSize,
            realname: this.formDate.student,
            regionName: this.formDate.teacher ? this.formDate.teacher : "1,2,3",
            gradeList: this.formDate.student1,
            classType: this.formDate.curriculum,
            saleId: this.formDate.teachingMethods,
            assistantId: this.formDate.deleteMethod,
            accomplishStatus: this.formDate.deleteMethod1,
            createStartDate: this.formDate.deleteTime.length > 1 ? this.formDate.deleteTime[0] : "",
            createEndDate: this.formDate.deleteTime.length > 1 ? this.formDate.deleteTime[1] : "",
            accomplishStartDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[0] : "",
            accomplishEndDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[1] : "",
            subjectGroupId: this.formDate.subjectGroupId,
        };
       try {
          axios.post(`${apiBaseUrl}/studentFeedback/exportStudentAll`, data, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo')},responseType: "blob" }).then((res) => {
              const blob = new Blob([res.data], { type: "application/vnd.ms-excel",});
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "综合反馈.xlsx"; 
              downloadLink.click();
              setTimeout(() => {
                loadingUtils.endLoading();
              }, 500);
          }).catch((err) => {
            this.$message.error('导出失败，请重试');
            setTimeout(() => {
              loadingUtils.endLoading();
            }, 500);
          });
       }catch(err){
         setTimeout(() => {
           loadingUtils.endLoading();
         }, 500);
       }

      },
  
      handleTeacherChange(){
        this.handleApigetStudentMsgList()
      },
      handleStudentChange(){
        this.handleApigetSubjectMsgList()
      },
      handleApigetStudentMsgList(){
        let data = { teacherId: this.ewReminder.teacher }
        ApigetStudentMsgList(data).then((res)=>{
          if(res){
             this.studentArr_s = res
          }
        })
      },
      handleApigetSubjectMsgList(){
        let data = { teacherId: this.ewReminder.teacher, studentId: this.ewReminder.student }
        ApigetSubjectMsgList(data).then((res)=>{
          if(res.data){
             this.subjectArr_s = res.data
          }
        })
      },
      // handleApiGetMessageState(){
      //   ApiGetMessageState().then((res)=>{
      //     if(res.code == 200){
  
      //       let dataTop = {
      //         xueguanshenhezhong: res.data.unfinishedWharn,
      //         teacherOk: res.data.messageTotal,
      //         teacherDaiTiJiao: res.data.accomplisWharn,
      //         marketOk: res.data.marketAccomplish,
      //         marketNotOk: res.data.marketUnfinished,
      //       }
      //       this.dataTop = dataTop
      //     }
      //   })
      // },
      addBtn(){
        this.isNewReminder = true
      },
      searchBtn () {
       this.getListData()
       this.handleGETImgList()
      },
      clearBtn(){
        this.handleAllclear()
        this.getListData()
      },
      dialogCler(){
        this.handleDialogclear()
      },
      dialogSubit(){
        let data = {
          id:"",
          msgType: 2,
          teacherId: this.ewReminder.teacher,
          studentId: this.ewReminder.student,
          subject: this.ewReminder.subject,
        }
        ApiExhortNews(data).then((res)=>{
          if(res.code == 200){
            // this.$message({type: 'success',message: '查询成功'});
            this.isNewReminder = false
            this.getListData()
            this.handleDialogclear()
          }else{
            this.$message({type: 'error',message: '添加失败'});
          }
        })
      },
      handlescreenshotCler(){
        this.screenshot = ""
        this.fileLists = [];
        this.showMsg = null
        this.screenshotShow = false
      },
      handlescreenshotSubmit(){
        let data = {
          msgId: this.showMsg.msgId,
          marketStatus: 1,
          remark: this.screenshot,
        }
        ApiStatus(data).then((res)=>{
          if(res.code == 200){
            this.handlescreenshotCler()
            this.getListData()
          }
        })
      },
      handleDialogclear(){
        this.isNewReminder = false
        this.ewReminder = {
          teacher:"",
          student:"",
          subject:"",
        }
      },
      handleAllclear(){
        this.searchSource222 = ""
        this.formDate = {
           student:"",
           teacher:"",
           student1:[],
           curriculum:"",
           teachingMethods:"",
           deleteMethod:"",
           deleteTime:[],
           dateTime:[],
           deleteMethod1:"",
           subjectGroupId:"",
       }

        this.pagination.pageNo = 1
        this.pagination.pageSize = 10
      },
      getListData(){
        this.isLoading = true
      
        let data = {
            projectTeacherId: this.searchSource222,
            pageNum: this.pagination.pageNo,
            pageSize: this.pagination.pageSize,
            realname: this.formDate.student,
            regionName: this.formDate.teacher ? this.formDate.teacher : "1,2,3",
            gradeList: this.formDate.student1,
            classType: this.formDate.curriculum,
            saleId: this.formDate.teachingMethods,
            assistantId: this.formDate.deleteMethod,
            accomplishStatus: this.formDate.deleteMethod1,
            createStartDate: this.formDate.deleteTime.length > 1 ? this.formDate.deleteTime[0] : "",
            createEndDate: this.formDate.deleteTime.length > 1 ? this.formDate.deleteTime[1] : "",
            accomplishStartDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[0] : "",
            accomplishEndDate: this.formDate.dateTime.length > 1 ? this.formDate.dateTime[1] : "",
            categoryIds: this.formDate.subjectGroupId,

        }
        axios.post(`${apiBaseUrl}/studentFeedback/findStudentPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }) .then((res)=>{
         isReturn(res.data.code)
         if(res.data.code == 200){
            if(res.data.data){
              this.tableData = res.data.data.records ? res.data.data.records : []
              this.isLoading = false
              this.pagination.pageNo = res.data.data.current
              this.pagination.total = res.data.data.total
              this.pagination.pageSize = res.data.data.size
              this.$message({type: 'success',message: '查询成功'});
            }else{
              this.tableData =  []
              this.pagination.pageNo = 1
              this.pagination.total = 0
              this.$message({type: 'success',message: '查询成功'});
              this.isLoading = false
            }
         }else{
            this.$message({type: 'error',message: '查询失败'});
            this.tableData =  []
            this.pagination.pageNo = 1
            this.pagination.total = 0
            this.isLoading = false
         }
        }).catch((err)=>{
          this.$message({type: 'error',message: err});
          this.isLoading = false
        })
      },
  
      showChatDetailEvent(even){
        this.showChatDetailTask = even
        this.row = null
      },
  
      detail(row){
        if(row.student && row.teacher){
          // this.$router.push({ path: "/chatDetailTask", query: { row } })
          this.row = row
          this.showChatDetailTask = true
        }else{
          this.$message({type: 'warning',message: '获取老师或学生错误信息'});
        }
      },
      handleSizeChange (v) {
        this.pagination.pageSize = v;
        this.getListData();
      },
  
      handleCurrentChange (v) {
        this.pagination.pageNo = v;
        this.getListData();
      },
  
      handleGetlistData(){
        this.$message({type: 'success',message: '已取消'});
      },
  
      changeMarke (row) {
  
        // if(row.msg.marketStatus == 1){
        //    this.$message({message: '审核状态必须已完成',type: 'warning' });
        // }else{
          this.$confirm('此操作将修改销售完成情况, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
               this.screenshotShow = true
               this.showMsg = row.msg
               row.msg.marketStatus = 2
            }).catch(() => {
              row.msg.marketStatus = 2
              this.$message({type: 'warning',message: '已取消'});
            });
        // }
  
      },
  
      handleImgClick(row) {
        this.showImg = row;
        this.isShowImg = true;
      },
  
      handleNewReminderClose(){
        this.isNewReminder = false
        this.handleDialogclear()
      },
  
      handleInitialization(){
        // getStudents().then(res => {
        //   this.studentArr = res.data
        // })
  
        getStudentsType(2).then(res => { this.studentArr = res.data  })
        getStudentsType(1).then(_res => {  this.studentArr1 = _res.data  })
  
        // getTeachers().then(res => {
        //   this.teacherArr = res.data
        // })

        axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ 
              this.teacherArr = res.data.data
        })


        axios.get(`${apiBaseUrl}/schedule/assistantList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
           let param = {  realname: "",   id: "" }
           this.teachers1 = response.data.data
        }) .catch(error => {  });



        axios.get(`${apiBaseUrl}/grade/getGrade`,{   headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  }  }) .then(res => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
          } else {
            this.$message({ message: "获取年级列表失败",   type: "error"  });
          }
        }).catch(error => {  });
        
        getSubject().then(res => {   this.subjectArr = res.data  })


      },
  
  
      getFileName(name) {
        return name.substring(name.lastIndexOf("."));
      },
      beforeUpload(file) {
        // 限制上传类型
        const fileExtensions =
          this.getFileName(file.name) === ".bmp" ||
          this.getFileName(file.name) === ".tif" ||
          this.getFileName(file.name) === ".gif" ||
          this.getFileName(file.name) === ".pcx" ||
          this.getFileName(file.name) === ".svg" ||
          this.getFileName(file.name) === ".psd" ||
          this.getFileName(file.name) === ".webp" ||
          this.getFileName(file.name) === ".apng" ||
          this.getFileName(file.name) === ".ai" ||
          this.getFileName(file.name) === ".avif" ||
          this.getFileName(file.name) === ".png" ||
          this.getFileName(file.name) === ".pdf"||
          this.getFileName(file.name) === ".jpg";
        //限制的上限为20M
        const max20M = file.size / 1024 / 1024 < 20;
        if (!fileExtensions) {
          this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
        }
        if (!max20M) {
          this.$message.error("上传文件大小不能超过 20MB!");
        }
        return fileExtensions && max20M;
      },
      handleUpload(option) {
        var obj = option.file.name;
        var index = obj.lastIndexOf(".");
        obj = obj.substring(index, obj.length);
        // 生成的文件名，保留文件后缀名，进行拼接
        let objName = getFileNameUUID() + this.getFileName(option.file.name);
        // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
        put(`mz_pc/${objName}`, option.file).then((res) => {
          console.log(res);
          this.screenshot = res.url
          // 上传成功之后，转换真实的地址
          signatureUrl(`mz_pc/${objName}`).then((res) => {
            console.log(res);
          });
        });
      },
      handleRemove(file, fileList) {
        this.fileLists = fileList;
        this.screenshot = ""
      },
  
  
    }
  
  }
  </script>
  
  
  <style scoped>
  header {
    text-align: left;
  }
  
  .pending {
    text-align: left;
  }
  
  .pending p {
    font-size: 14px;
  }
  
  .pending_bottom {
    width: 100%;
    height: 140px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-radius: 10px;
  }
  
  .pending_item {
    width: 170px;
    height: 100px;
    border-radius: 10px;
  }
  
  .pending_item p {
    margin-top: 20px;
    margin-left: 25px;
  }
  
  .leave {
    background: linear-gradient(to right, #028bcf, #80d0f6);
  }
  
  .renew {
    background: linear-gradient(to right, #fdbe29, #fecf64);
  }
  
  .communication {
    background: linear-gradient(to right, #5d9656, #aac8a6);
  }
  
  .afterClass {
    background: linear-gradient(to right, #ff698a, #fe9f74);
  }
  
  .first {
    background: linear-gradient(to right, #d87ea3, #e3c5c6);
  }
  
  .classroom {
    background: linear-gradient(to right, #1da8aa, #94e0dd);
  }
  
  .issue {
    background: linear-gradient(to right, #f4ab56, #f6cd9e);
  }
  
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 88%;
    margin: 0 ;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  
  .el-upload {
    border: 1px dashed #d9d9d9 !important;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .demo-form-inline .el-form-item {
    margin-right: 30px;
  }
  
  /* 兼容移动端 */
  @media screen and (max-width: 750px) {
    .fiveLessons {
      width: 1430px;
    }
  
    /* 兼容移动端 */
    #aa>>>.fiveLessons {
      width: 70% !important;
    }
  }
  .el-upload .el-upload--text{
    margin: 0 auto !important;
  }
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/ComprehensiveFeedback/ComprehensiveFeedback.vue